import * as AdminActions from '../actions/adminActions';

const defaultState = {
    adminInfo: {},
    adminCourses: [],
    adminCurrentCourse: {},
    studentProfile: {},
    engagement: {},
    engagementStats: {
        completion: 0,
        hours: 0,
        expectedTime: 0,
        maxPoints: 0,
        studentCount: 0,
        repeatRatio: 0
    },
    engagementLoading: false,
    courseInstructors: [],
    engagementCharts: {
        attentiveness: null,
        sessionDuration: null,
        quiz: null,
        tests: null,
        attendance: null,
        watchTime: null,
        demographics: null,
        demographicsPie: null,
        browsers: null,
        subjects: null,
    },
    engagementChartsLoading: {
        attentiveness: false,
        sessionDuration: false,
        quiz: false,
        tests: false,
        attendance: false,
        watchTime: false,
        demographics: false,
        demographicsPie: false,
        browsers: false,
        subjects: false,
    },
    engagementChartsLength: {
        attentiveness: 1,
        sessionDuration: 1,
        quiz: 1,
        tests: 1,
        attendance: 1,
        watchTime: 1,
        demographics: 1,
        browsers: 1,
        subjects: 1,
    },
    leaderboard: [],
    courseUser: [],
    videoQuestions: [],
    quiz: {},
    ul: [],
    us: [],
    course: null,
    kpiView: '',
    kpiLength: 1,
    countryLength: 1,
    kpiStats: {
        users: {
            stat: 'kpiUsers',
            current: 0,
            previous: 0,
            progress: 0,
            persistent: true
        },
        sessions: {
            stat: 'kpiSessions',
            current: 0,
            previous: 0,
            progress: 0,
            persistent: false
        },
        videoTime: {
            stat: 'kpiVideoTime',
            current: 0,
            previous: 0,
            progress: 0,
            persistent: false
        },
        revenue: {
            stat: 'kpiRevenue',
            current: 0,
            previous: 0,
            progress: 0,
            persistent: false
        },
        messages: {
            stat: 'kpiMessages',
            current: 0,
            previous: 0,
            progress: 0,
            persistent: false
        }
    },
    views: [
        {view: 'users', name: 'Users', count: 0, progress: 0},
        {view: 'sessions', name: 'Sessions', count: 0, progress: 0},
        {view: 'videoTime', name: 'Video Time', count: 0, progress: 0},
        {view: 'revenue', name: 'Revenue', count: 0, progress: 0},
        {view: 'messages', name: 'Messages', count: 0, progress: 0},
    ],
    charts: {
        users: null,
        sessions: null,
        videoTime: null,
        revenue: null,
        messages: null,
        countries: null,
        engagement: null,
        demographs: null,
        browsers: null,
        activity: null
    },
    tableData: [],
    tableCount: 1,
    tableLoading: false,
    countryLoading: false,
    students: [],
    studentCount: 0,
    studentSubjects: [],
    loadingStudents: false,
    comments: [],
    commentCount: 0,
    loadingComments: false

};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'GOT_KPI_STATS':
            return {
                ...state,
                kpiStats: action.payload
            };
        case 'GOT_ENGAGEMENT_STAT':
            return {
                ...state,
                engagementStats: {
                    ...state.engagementStats,
                    [action.payload.name]: action.payload.result
                }
            }
        case 'LOADING_COMMENTS':
            return {
                ...state,
                loadingComments: true
            }
        case 'UPDATE_COMMENT':
            return {
                ...state,
                comments: state.comments.map(c => {
                    if (c.id === action.payload.id) {
                        return {
                            ...c,
                            ...action.payload
                        }
                    } else {
                        return c
                    }
                })
            }
        case 'GOT_COMMENTS':
            return {
                ...state,
                comments: state.comments ? action.payload.skip > 0 ? state.comments.concat(action.payload.data) : action.payload.data : action.payload.data,
                commentCount: action.payload.count,
                loadingComments: false
            }
        case AdminActions.ACTION_GET_INFO:
            return {
                ...state,
                ...action.payload
            };
        case 'SET_LOADING_STUDENTS':
            return {
                ...state,
                loadingStudents: action.payload
            }
            break;
        case 'SEARCH_STUDENT_UPDATED':
            return {
                ...state,
                students: state.students.map(s => {
                    if (s.id === action.payload.id) {
                        return {
                            ...s,
                            ...action.payload.fields
                        }
                    } else {
                        return s;
                    }
                })
            }
            break;
        case 'GOT_STUDENT_NOTES':
            return {
                ...state,
                students: state.students.map(s => {
                    if(s.id === action.payload.cuId){
                        return {
                            ...s,
                            notes: s.notes ? s.notes.concat(action.payload.notes) : action.payload.notes
                        }
                    }else{
                        return s
                    }
                })
            }
        case 'ADDED_CU_NOTE':
            return {
                ...state,
                students: state.students.map(s => {
                    if(s.id === action.payload.courseUserId){
                        return {
                            ...s,
                            notes: s.notes ? s.notes.concat(action.payload) : [action.payload],
                            noteCount: s.noteCount ? s.noteCount + 1 : 1
                        }
                    }else{
                        return s
                    }
                })
            }
        case 'ADDED_CU_NOTE':
                return {
                    ...state,
                    students: state.students.map(s => {
                        if(s.id === action.payload.courseUserId){
                            return {
                                ...s,
                                notes: s.notes ? s.notes.map(n => {
                                    if(n.id === action.payload.id){
                                        return {
                                            ...n,
                                            ...action.payload
                                        }
                                    }else{
                                        return n
                                    }
                                }) : [action.payload],
                                noteCount: s.noteCount ? s.noteCount + 1 : 1
                            }
                        }else{
                            return s
                        }
                    })
                }
            case 'DELETED_CU_NOTE':
                    return {
                        ...state,
                        students: state.students.map(s => {
                            if(s.id === action.payload.courseUserId){
                                return {
                                    ...s,
                                    notes: s.notes ? s.notes.filter(n => n.id !== action.payload.id) : s.notes,
                                    noteCount: s.noteCount ? s.noteCount - 1 : 0
                                }
                            }else{
                                return s
                            }
                        })
                    }
        case 'APPEND_CONSOLE_STUDENTS':
            return {
                ...state,
                students: state.students.concat(action.payload.students),
                loadingStudents: false
            }
        case 'GOT_CONSOLE_STUDENTS':
            return {
                ...state,
                students: action.payload.students,
                studentCount: action.payload.studentCount,
                loadingStudents: false
            }
        case 'GOT_CONSOLE_STUDENT_SUBJECT':
            return {
                ...state,
                students: state.students.map(s => {
                    if(s.id === action.payload.cuId){
                        return {
                            ...s,
                            cs: action.payload.subject
                        }
                    }else{
                        return s
                    }
                })
            }
        case 'GOT_STUDENTS_SUBJECTS':
            return {
                ...state,
                studentSubjects: action.payload
            }
        case 'GOT_LEADERBOARD':
            return {
                ...state,
                leaderboard: action.payload
            }
        case 'GOT_LEADERBOARD_COUNT':
            return {
                ...state,
                leaderboardCount: action.payload
            }
        case 'GOT_COURSE_INSTRUCTORS':
            return {
                ...state,
                courseInstructors: action.payload
            }
        case 'SET_ENGAGEMENT_CHART_LOADING':
            return {
                ...state,
                engagementChartsLoading: {
                    ...state.engagementChartsLoading,
                    [action.payload.view]: true
                },
                engagementChartsLength: {
                    ...state.engagementChartsLength,
                    [action.payload.view]: action.payload.length
                }
            }
        case 'SET_ENGAGEMENT_CHART':
            return {
                ...state,
                engagementCharts: {
                    ...state.engagementCharts,
                    [action.payload.view]: action.payload.data
                },
                engagementChartsLoading: {
                    ...state.engagementChartsLoading,  
                    [action.payload.view]: false
                }
            }
        case 'GOT_ENGAGEMENT_PAGE':
            return {
                ...state,
                engagement: action.payload
            }
        case 'SET_ADMIN_COURSES': 

            return {
                ...state,
                adminCourses: action.payload
            }

        case 'SET_CURRENT_ADMIN_COURSE':
            return {
                ...state,
                adminCurrentCourse: action.payload
            }
        case 'GOT_VIEW_COUNT': 
            return {
                ...state,
                views: state.views.map(v => {
                    if(v.view === action.payload.view) {
                        return {
                            ...v,
                            count: action.payload.count,
                            progress: action.payload.progress ? action.payload.progress : 0
                        }
                    } else {
                        return v
                    }
                })
            }
        case 'KPI_LOADING':
            return {
                ...state,
                kpiView: action.payload.view,
                kpiLength: action.payload.length,
                kpiLoading: true
            }
        case 'GOT_KPI_CHART':
            return {
                ...state,
                kpiView: action.payload.view,
                kpiLength: action.payload.length,
                kpiLoading: false,
                charts: {
                    ...state.charts,
                    [action.payload.view]: action.payload.data
                }
            }
        case 'GOT_ADMIN_CHART':
            return {
                ...state,
                countryLength: action.payload.length,
                countryLoading: false,
                charts: {
                    ...state.charts,
                    [action.payload.view]: action.payload.data
                }
            }
        case 'GOT_TABLE_DATA_COUNT':
            return {
                ...state,
                tableCount: action.payload,
                tableLoading: false
            }
        case 'GOT_TABLE_DATA':
            return {
                ...state,
                tableData: action.payload,
                tableLoading: false
            }
        case 'LOADING_TABLE': 
            return {
                ...state,
                tableLoading: true
            }
        case 'EDITED_CU':
            return {
                ...state,
                courseUser: state.courseUser.map(c => {
                    if(c.id === action.payload.id){
                        return {
                            ...c,
                            ...action.payload
                        }
                    }else{
                        return c
                    }
                })
            }
        case 'GOT_SINGLE_COURSE_USER':
            return {
                ...state,
                courseUser: [action.payload]
            }
        case AdminActions.ACTION_GET_INFO_ABOUT_STUDENT:
            return {
                ...state,
                studentProfile: action.payload
            };
        case 'REMOVED_QUIZ':
            return {
                ...state,
                quiz: {}
            }
            break;
        case 'GOT_COMPLETED_SUBJECTS':
            return {
                ...state,
                us: action.payload
            }
        case 'GOT_COMPLETED_USER_LECTURES':
            return {
                ...state,
                ul: action.payload
            }
        case 'REMOVED_USERLECTURE':
            return {
                ...state,
                ul: state.ul.filter(l => l.id !== action.payload)
                
            }
            break;
        case 'ADDED_USERLECTURE':
            return {
                ...state,
                ul: state.ul.concat(action.payload) || []
            }
            break;
        case 'GOT_COURSE_AND_SUBJECTS':
            return {
                ...state,
                course: action.payload
            };
        case 'UPDATED_USERLECTURE':
            return {
                ...state,
                ul: state.ul.map(l => {
                    if(l.id === action.payload.id){
                        return {
                            ...l,
                            ...action.payload
                        }
                    }else{
                        return l
                    }
                })
            }
        case 'GOT_COURSE_USERS':
            return {
                ...state,
                courseUser: action.payload
            }
        case 'GOT_QUIZ_RESULTS':
            return {
                ...state,
                quiz: action.payload.length > 0 ? action.payload[0] : []
            }
        case 'GOT_VIDEO_QUESTIONS':
            return {
                ...state,
                videoQuestions: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/adminReducer.js